import type { ActivitiesSpreadsheetImportFormValues, DeleteRoutes, EditRoute, InputActivity, NewRoute, ParsedSpreadsheetTab, RoutingSettings } from '@cobliteam/api-lib';
import type { UUID } from '@cobliteam/common-types';
import type {
  DeleteRoutesFailed,
  DeleteRoutesRequest,
  DeleteRoutesSucceeded,
  EditRouteFailed,
  EditRouteRequest,
  EditRouteSucceeded,
  ImportActivitiesSpreadsheetFailed,
  ImportActivitiesSpreadsheetRequest,
  ImportActivitiesSpreadsheetSucceeded,
  ParseSpreadsheetFailed,
  ParseSpreadsheetRequest,
  ParseSpreadsheetSucceeded,
  RoutingFailed,
  RoutingRequest,
  RoutingSucceeded,
} from './actions';
import { ActionTypes } from './actionTypes';

export const routingRequest = (routingSettings: RoutingSettings, isAccessAllowed: boolean): RoutingRequest => ({
  type: ActionTypes.ROUTING_REQUEST,
  payload: { ...routingSettings, isAccessAllowed },
});

export const routingFailed = (): RoutingFailed => ({
  type: ActionTypes.ROUTING_FAILED,
});

export const routingSucceeded = (routes: NewRoute[]): RoutingSucceeded => ({
  type: ActionTypes.ROUTING_SUCCEEDED,
  payload: routes,
});

export const editRouteRequest = (payload: { editRoute: EditRoute; notifyRouteEditRequestResult?: boolean; isAccessAllowed: boolean }): EditRouteRequest => ({
  type: ActionTypes.EDIT_ROUTE_REQUEST,
  payload,
});

export const editRouteFailed = (): EditRouteFailed => ({
  type: ActionTypes.EDIT_ROUTE_FAILED,
});

export const editRouteSucceeded = (route: NewRoute): EditRouteSucceeded => ({
  type: ActionTypes.EDIT_ROUTE_SUCCEEDED,
  payload: route,
});

export const deleteRoutesRequest = (payload: { routesToDelete: DeleteRoutes; notifyDeleteRouteRequestResult?: boolean }): DeleteRoutesRequest => ({
  type: ActionTypes.DELETE_ROUTES_REQUEST,
  payload,
});

export const deleteRoutesFailed = (): DeleteRoutesFailed => ({
  type: ActionTypes.DELETE_ROUTES_FAILED,
});

export const deleteRoutesSucceeded = (deletedRoutes: UUID[]): DeleteRoutesSucceeded => ({
  type: ActionTypes.DELETE_ROUTES_SUCCEEDED,
  payload: deletedRoutes,
});

export const parseSpreadsheetRequest = (spreadsheet: File): ParseSpreadsheetRequest => ({
  type: ActionTypes.PARSE_SPREADSHEET_REQUEST,
  payload: spreadsheet,
});

export const parseSpreadsheetFailed = (): ParseSpreadsheetFailed => ({
  type: ActionTypes.PARSE_SPREADSHEET_FAILED,
});

export const parseSpreadsheetSucceeded = (data: ParsedSpreadsheetTab[]): ParseSpreadsheetSucceeded => ({
  type: ActionTypes.PARSE_SPREADSHEET_SUCCEEDED,
  payload: data,
});

export const importActivitiesSpreadsheetRequest = (formValues: ActivitiesSpreadsheetImportFormValues): ImportActivitiesSpreadsheetRequest => ({
  type: ActionTypes.IMPORT_ACTIVITIES_SPREADSHEET_REQUEST,
  payload: formValues,
});

export const importActivitiesSpreadsheetFailed = (): ImportActivitiesSpreadsheetFailed => ({
  type: ActionTypes.IMPORT_ACTIVITIES_SPREADSHEET_FAILED,
});

export const importActivitiesSpreadsheetSucceeded = (spreadsheetImportResultAddresses: InputActivity[]): ImportActivitiesSpreadsheetSucceeded => ({
  type: ActionTypes.IMPORT_ACTIVITIES_SPREADSHEET_SUCCEEDED,
  payload: spreadsheetImportResultAddresses,
});
